import React from 'react'
import {Field} from 'formik'
import {TfiPlus} from 'react-icons/tfi'
import {AiFillDelete} from 'react-icons/ai'

import {beforeUpload, ACCEPT_IMAGES_TYPES} from 'utils/beforeUpload'
import {validateAfterChangeImageField} from 'utils/validateAfterChangeImageField'
import {Avatar, Upload} from '../ui'

const AvatarField = ({fieldName = 'avatar', fileFieldName = 'avatarFile', prevLogoField, disabled}) => {
    const onSetFormFile = (form, fieldName, file) => {
        if (!file?.[0]) return

        const previewUrl = URL.createObjectURL(file[0])

        form.setFieldValue(fieldName, previewUrl)
        form.setFieldValue(fileFieldName, file[0])

        if (prevLogoField) {
            form.setFieldValue(prevLogoField, null)
        }

        validateAfterChangeImageField(form, fieldName, previewUrl)
    }

    const clearAvatarField = (form, fieldName, e) => {
        e?.stopPropagation?.()

        form.setFieldValue(fieldName, '')
        form.setFieldValue(fileFieldName, null)

        if (prevLogoField) {
            form.setFieldValue(prevLogoField, null)
        }

        validateAfterChangeImageField(form, fieldName, '')
    }

    const handleFileRemove = (form, fieldName) => {
        form.setFieldValue(fieldName, '')
        form.setFieldValue(fileFieldName, null)

        if (prevLogoField) {
            form.setFieldValue(prevLogoField, null)
        }

        validateAfterChangeImageField(form, fieldName, '')
    }

    return (
        <Field name={fieldName}>
            {({field, form}) => {
                const avatarProps = field.value ? {src: field.value} : {}

                return (
                    <Upload
                        className={disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
                        onChange={onSetFormFile.bind(null, form, field.name)}
                        onFileRemove={() => handleFileRemove(form, field.name)}
                        showList={false}
                        uploadLimit={1}
                        accept={ACCEPT_IMAGES_TYPES.toString()}
                        beforeUpload={beforeUpload}
                        disabled={disabled}
                    >
                        <Avatar
                            size={90}
                            shape="circle"
                            icon={<TfiPlus className="text-xs text-gray-800" />}
                            {...avatarProps}
                        />
                        {field.value && (
                            <div className="avatar-field-delete" onClick={(e) => clearAvatarField(form, field.name, e)}>
                                <AiFillDelete />
                            </div>
                        )}
                    </Upload>
                )
            }}
        </Field>
    )
}

export default AvatarField
